import { render } from "./AddBalanceModal.vue?vue&type=template&id=7413981c&scoped=true"
import script from "./AddBalanceModal.vue?vue&type=script&lang=js"
export * from "./AddBalanceModal.vue?vue&type=script&lang=js"

import "./AddBalanceModal.vue?vue&type=style&index=0&id=7413981c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7413981c"]])

export default __exports__